import { render, staticRenderFns } from "./relations.vue?vue&type=template&id=daa3282c&scoped=true"
import script from "./relations.vue?vue&type=script&lang=js"
export * from "./relations.vue?vue&type=script&lang=js"
import style0 from "./relations.vue?vue&type=style&index=0&id=daa3282c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa3282c",
  null
  
)

export default component.exports